<template>
	<div id="app_main" >
		<transition :name="names">
			<keep-alive :include="keepAlive">
				<!-- <router-view class="router-view" v-if='flag == "true"'></router-view> -->
				<router-view class="router-view"></router-view>
			</keep-alive>
			<!-- <router-view class="router-view"></router-view> -->
		</transition>
		<van-overlay :show="$store.state.loadShow" z-index="11">
			<div class="load_overlay" @click.stop>
				<div class="load_overlay_content">
					<van-loading size="24px" color="#0277FC" vertical>{{$store.state.loadText}}</van-loading>
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	export default {
		name: "app",
		data() {
			return {
				//flag: window.localStorage.getItem('tips'),
			};
		},
		computed: {
			...mapGetters(["direction", "keepAlive"]),
			// 路由跳转动画
			names() {
				return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
			},
		},
		methods: {
			init() {
				// if(window.plus){
				// 	console.log('window.plus1', window.plus)
				// 	console.log('window.plus2', window.plus.os.name)
				// }
			},
		},
		mounted() {
			this.init()
		},
		created() {},
	};
</script>

<style lang="scss" scoped>
	@import "./styles/global.css";

	#app_main {
		font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Helvetica Neue",
			Helvetica, Segoe UI, Arial, Roboto, "PingFang SC", "miui",
			"Hiragino Sans GB", "Microsoft Yahei", sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		background: #fff;
		width: 100vw;
		height: 100vh;
		overflow: scroll;
		-webkit-overflow-scrolling: touch;
		position: absolute;
		// padding-bottom: env(safe-area-inset-bottom);
		left: 0;
		top: 0;
		// padding-bottom: 34px;
		// bottom:34px;
	}

	// .vux-pop-out-enter-active,
	// .vux-pop-out-leave-active,
	// .vux-pop-in-enter-active,
	// .vux-pop-in-leave-active {
	// 	will-change: transform;
	// 	transition: all 400ms;
	// 	height: 100%;
	// 	position: absolute;
	// 	backface-visibility: hidden;
	// 	perspective: 1000;
	// }

	// .vux-pop-out-enter {
	// 	opacity: 0;
	// 	transform: translate3d(-100%, 0, 0);
	// }

	// .vux-pop-out-leave-active {
	// 	opacity: 0;
	// 	transform: translate3d(100%, 0, 0);
	// }

	// .vux-pop-in-enter {
	// 	opacity: 0;
	// 	transform: translate3d(100%, 0, 0);
	// }

	// .vux-pop-in-leave-active {
	// 	opacity: 0;
	// 	transform: translate3d(-100%, 0, 0);
	// }

	// /*淡入淡出的方法*/
	// .router-fade-enter-active,
	// .router-fade-leave-active {
	// 	transition: opacity 0.3s;
	// }

	// .router-fade-enter,
	// .router-fade-leave-active {
	// 	opacity: 0;
	// }
</style>